module.exports = __webpack_public_path__ + "img/cken1.3ea4b4c8.jpeg";